import { EuiLink } from "@elastic/eui";
import React from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "truckClass",
        name: <FormattedMessage id="truck-type.class" />,
        render: (item) => <span>{_.startCase(item)}</span>,
        sortable: true,
    },
    {
        field: "box",
        name: <FormattedMessage id="truck-type.box" />,
        render: (item) => <span>{_.startCase(item)}</span>,
        sortable: true,
    },
    {
        field: "condition",
        name: <FormattedMessage id="truck-type.condition" />,
        render: (item) => <span>{_.startCase(item)}</span>,
        sortable: true,
    },
    {
        field: "capacityInTon",
        name: <FormattedMessage id="truck-type.capacity-in-ton" />,
        sortable: true,
    },
    {
        field: "numOfPallets",
        name: <FormattedMessage id="truck-type.pallets-count" />,
        sortable: true,
    },
    {
        field: "createdAt",
        name: <FormattedMessage id="truck-type.creation-date" />,
        dataType: "date",
        sortable: true,
    },
    {
        field: "creatorId",
        name: <FormattedMessage id="truck-type.creator.id" />,
        sortable: false,
    },
    {
        field: "creatorEmail",
        name: <FormattedMessage id="truck-type.creator.email" />,
        sortable: false,
    },
    {
        field: "creatorType",
        name: <FormattedMessage id="truck-type.creator.type" />,
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
